import axios from "axios";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/admin`, withCredentials: true, timeout: 15000 });
let csrf = "";

export const setCsrf = (t) => { csrf = t || ""; };
api.interceptors.request.use((cfg) => {
  if (cfg.method !== "get") cfg.headers["X-CSRF-Token"] = csrf;
  return cfg;
});

export async function adminCall(method, url, data, params) {
  try {
    const res = await api.request({ method, url, data, params });
    return { ok: true, data: res.data };
  } catch (err) {
    const status = err.response?.status;
    const detail = err.response?.data?.detail;
    return { ok: false, status, message: typeof detail === "string" ? detail : "Something went wrong. Please try again." };
  }
}
